import React, { useEffect,useCallback } from "react";
import "../layout/layout.css";

import Sidebar from "../components/sidebar/Sidebar";
import Header from "../components/header/Header";
import { ToastContainer } from "react-toastify";

import { useSelector, useDispatch } from "react-redux";
import { setAppColor, setAppMode } from "../app/themeSlice";


const Layout = (props) => {
  const { children } = props;
  const themeReducer = useSelector((state) => state.theme);
  // const { activeSession } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();

  // localStorage.clear();

  useEffect(() => {
    const themeClass = localStorage.getItem("themeMode", "theme-mode-light");
    const colorClass = localStorage.getItem("colorMode", "theme-mode-light");
    dispatch(setAppMode(themeClass));
    dispatch(setAppColor(colorClass));
  }, [dispatch]);

  // const selectedTheme = useSelector((state) => state.theme.mode);

  

  return (
    <>
    
      <ToastContainer
      // theme={selectedTheme === "theme-mode-light" ? "dark" : "light"}
      />

      <div className={`layout ${themeReducer.mode} ${themeReducer.color}`}>
        <Sidebar {...props} />
      
        <div className="ez-layout-content">
          <Header />
         
          <div className="ez-content-main">{children}</div>
        </div>
      </div>
    </>
  );
};

export default Layout;
